import { createBrowserRouter, type RouteObject } from 'react-router-dom'

import {
    Admins,
    Auth,
    Dms,
    Doctors,
    EditDoctor,
    Faq,
    InitialPage,
    Services,
    Settings,
    Companies as DMSCompanies,
    Company as DMSCompany,
    Insureds as DMSInsureds,
    Insured as DMSInsured,
    Contracts as DMSContracts,
    Programs as DMSPrograms
} from '@/pages'
import { type IRoutes } from '@App/types/common'
import { routes, ROLE_MAPPER } from '@Config/config'

import { Layout } from './Layout'

const { AUTH, DOCS, SRVS, FAQS, ADMN, STGS, DMSM } = routes
const { RADMN, SADMN, DMSMR } = ROLE_MAPPER

export const routesConfig: IRoutes[] = [
    { route: '/', component: <InitialPage />, title: null, allowedRoles: [RADMN, SADMN, DMSMR] },
    { route: DOCS, component: <Doctors />, title: 'Врачи', allowedRoles: [RADMN, SADMN] },
    { route: `${DOCS}/:id`, component: <EditDoctor />, title: null, allowedRoles: [RADMN, SADMN] },
    { route: SRVS, component: <Services />, title: 'Услуги', allowedRoles: [RADMN, SADMN] },
    { route: FAQS, component: <Faq />, title: 'FAQ', allowedRoles: [RADMN, SADMN] },
    { route: STGS, component: <Settings />, title: 'Настройки', allowedRoles: [RADMN, SADMN] },
    { route: ADMN, component: <Admins />, title: 'Управление', allowedRoles: [SADMN] },
    {
        route: `${DMSM}`,
        component: <Dms />,
        title: 'ДМС',
        allowedRoles: [SADMN, DMSMR],
        children: [
            { route: '', title: null, allowedRoles: [SADMN, DMSMR] },
            { route: 'insureds', component: <DMSInsureds />, title: null, allowedRoles: [SADMN, DMSMR] },
            {
                route: `insureds/addInsured`,
                component: <DMSInsured type='add' />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            },
            {
                route: `insureds/:insuredId`,
                component: <DMSInsured type='edit' />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            },
            { route: 'companies', component: <DMSCompanies />, title: null, allowedRoles: [SADMN, DMSMR] },
            {
                route: `companies/addCompany`,
                component: <DMSCompany type='add' />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            },
            {
                route: `companies/:companyId`,
                component: <DMSCompany type='edit' />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            },
            {
                route: `companies/:companyId/contracts`,
                component: <DMSContracts />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            },
            {
                route: `companies/:companyId/contracts/:contractId/programs`,
                component: <DMSPrograms />,
                title: null,
                allowedRoles: [SADMN, DMSMR]
            }
        ]
    },
    { route: AUTH, component: <Auth />, title: null, allowedRoles: [RADMN, SADMN, DMSMR] },
    { route: '*', component: <h1>ERROR PAGE 404</h1>, title: null, allowedRoles: [SADMN, RADMN, SADMN] }
]

const mapRoutes = (routes: IRoutes[]): RouteObject[] =>
    routes.map(({ route, component, children }) => {
        const routeObject: RouteObject = {
            path: route,
            element: component
        }
        if (children && children.length > 0) {
            routeObject.children = mapRoutes(children)

            const hasIndexRoute = children.some((child) => child.route === '')
            if (!hasIndexRoute) {
                routeObject.children.unshift({
                    index: true,
                    element: <div>Выберите раздел</div>
                })
            }
        }

        return routeObject
    })
export const router = createBrowserRouter([{ element: <Layout />, children: mapRoutes(routesConfig) }])
